import * as React from "react";
import { useFormContext } from "react-hook-form";
import { NGLabelText } from "../../../newcomponents/text/labelText";
import { Gvc } from "../../../schema/types/gvc";
import { FormNGKindSelect } from "./components/FormNGKindSelect";
import { DomainInput } from "./types/input";
import { linksOf } from "../../../services/cpln";

interface Props {}
export const CreateNGAdvancedPathBasedGvc: React.FC<Props> = ({}) => {
  const { control, watch, setValue } = useFormContext<DomainInput>();

  const dryRunNameOnly = watch("dryRun.nameOnly.value") || {};
  const routingMode = watch("advanced.spec.routingMode") || "";

  if (dryRunNameOnly.status !== 200) {
    return null;
  }

  if (routingMode !== "pathBased") {
    return null;
  }

  return (
    <div className="mb-8">
      <NGLabelText className="cursor-default">GVC Selection</NGLabelText>
      <FormNGKindSelect<Gvc>
        name="gvc.name"
        control={control}
        kind="gvc"
        optionValueAs={`name`}
        className="color-default"
        style={{ width: 600 }}
        onChangeExtra={(_, item) => {
          const link = linksOf(item).self!;
          setValue(`gvc.link`, link);
          setValue(`gvc.alias`, item.alias || "");
        }}
      />
    </div>
  );
};
